const recruiterProspects = [
	{
		path: '/jobs/recruiter-prospects',
		name: 'jobs-recruiter-prospects-list',
		component: () => import(/* webpackChunkName: "JobsRecruiterProspects" */ '@/views/jobs/recruiter-prospects/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,recruiter-prospects',
		},
	},
]

export default recruiterProspects
